exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar[data-v-66add8c5] {\n  width: 120px;\n  height: 80px;\n}\n.el-icon-plus[data-v-66add8c5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 1px dashed #dbdbdd;\n}\n.progress[data-v-66add8c5] {\n  margin-top: 10px;\n  width: 300px;\n}\n", ""]);

// exports
